import * as React from "react";
import { Outlet } from "react-router-dom";
import i18n from "i18next";
import Sidebar from "src/components/Sidebar";
import getMenu from "./menu";
import { Container } from "rsuite";
import classNames from "classnames";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const ClientSettingsRootPage = _ref => { let {} = _ref; const [expanded, setExpanded] = React.useState(window.innerWidth > 768); const containerClasses = classNames("page-container", { "container-full": !expanded }); return /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsx(Sidebar, { header: i18n.t("project.label"), menuList: getMenu(), expanded: expanded, setExpanded: setExpanded }, "sidebar"), /*#__PURE__*/ _jsx(Container, { className: containerClasses, children: /*#__PURE__*/ _jsx(Outlet, {}) })] }); };
export default ClientSettingsRootPage;
